export default __webpack_public_path__ + "static/media/icon-highlight-video.7c265d0e.svg";